<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordocas/svgCas40bg.svg" />
    <span class="normalTheme pageInstruction" style="left: 67px; top: 141px">
      <p>Copia aquí el texto corregido.</p>
    </span>
    <span
      style="
        outline: 1px solid #a6a6a6;
        width: 954px;
        height: 522px;
        left: 37px;
        top: 192px;
        z-index: 2;
        position: absolute;
      "
    ></span>
    <saved-input-long
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      maxlength="250"
      style="line-height: 74px"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 71px;
  top: 40px;
}
#inputField01 {
  position: absolute;
  width: 814px;
  height: 522px;
  left: 37px;
  top: 192px;
  margin-left: 50px;
  margin-top: 10px;
  font-size: 33px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  z-index: 10;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 157.mp4"],
    };
  },
};
</script>